import AccessCodeGate from '../components/AccessCodeGate';
import { laravelAsset } from '../services/accessCodeService';

function AccessAudiobook() {
  return (
    <AccessCodeGate
      type="AUDIOBOOK"
      title="AUDIOBOOK"
      imageSrc={laravelAsset('images/new/1.png')}
      buttonLabel="ACCESS AUDIOBOOK"
    />
  );
}

export default AccessAudiobook;
